import {
  Form,
  Input,
  Modal,
  Select,
  Space,
  Button,
  Tooltip,
  message,
  DatePicker,
  Flex,
  Tag,
  Row,
  Col,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef
} from "react";
import {
  MailOutlined,
  CheckOutlined,
  CloseOutlined,
  MenuOutlined,
  FormOutlined,
  HomeOutlined
} from "@ant-design/icons";
import parse from 'html-react-parser';
import http from "@/utils/http";
import moment from "moment";
import api from "@/utils/api";
import dayjs from "dayjs";
import PDFModal from "@/views/AccountPayable/ApprovalSummary/component/PDFModal"
import { useLocation } from 'react-router-dom';
import AddModal from "@/views/AccountPayable/UtilityPayment/component/AddModal" ;
import { CustomTable, CustomTableExtend, CustomUpload, CustomUploadNew1 } from "@/hocComponents";
import commonFn from "@/utils/commonFn";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [openApproval, setOpenApproval] = useState(false);
  const [filedModalFlag, setFiledModalFlag] = useState(false);
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [filePaths, setFilePaths] = useState([]);
  const [detailRecord, setDetailRecord] = useState({});
  const [approvedOrRejected, setApprovedOrRejected] = useState('Approved');
  const [approvalForm,] = Form.useForm();
  const [selectedList, setSelectedList] = useState([]);
  
  const [currentRecord, setCurrentRecord] = useState(null);
  const [propTypeList, setPropTypeList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const PDFModalRef = useRef();

  const [uploadInvoiceFlag, setUploadInvoiceFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const customUploadNewRef = useRef(null);

  const initTableHead = {
    amount: null,
    materialRemark: null,
    jobs: null,
    glAcct: null,
    invoiceDateAp: null,
    storeName: null,
    unitAddress: null,
    requestNo: null,
    supervisor: null,
    vendorType: null,
    vendorName: null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const [addopen, setAddOpen] = useState(false);
  const [addRecord, setAddRecord] = useState(null);
  const [form] = Form.useForm();
  const [formTenant] = Form.useForm();

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Pay Amount',
      dataIndex: "amount",
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'amount'),
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={(e) => {
              e.preventDefault();
              setCurrentRecord(record)
              setUploadInvoiceFlag(true)
            }}
            className="CA-AS-AmountStyle"
          >
            <div>{commonFn.amountToDollarFn(text)}</div>
          </span>
        )
      },
    },
    {
      title: 'Prop #',
      dataIndex: "propCode",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'propCode'),
    },
    {
      title: "Unit Address, City State",
      dataIndex: "unitAddress",
      // titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "unitAddress"),
    },
    {
      title: "Status",
      dataIndex: "status",
      titleType: 'Input',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'status'),
      render: (text, record) => {
        return (
          <a onClick={() => {
            const url = `${window.location.origin}#/JobRequests/Maintenance/Details?id=${record?.maintenanceId}`;
            window.open(url, "_blank", "noopener,noreferrer");
          }}>
            <Tag color="#3c8dbc">{text}</Tag>
          </a>
        );
      },
    },
    {
      title: 'Material Remark',
      dataIndex: "materialRemark",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      isWrapFlag: 300,
      onChange: e => tableFilterFn(e, 'materialRemark'),
    },
    {
      title: "Job Type",
      dataIndex: "jobs",
      titleType: "Input",
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, "jobType"),
      width: 200,
      render: (text) => (
        <Flex gap="4px 0" wrap>
          {text?.map((item) => (
            <Tooltip title={item}>
              <Tag
                  // color="rgba(109, 140, 81, 0.12)"
                color="blue"
                style={{
                    // color: "#6D8C51",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {item}
              </Tag>
            </Tooltip>
          ))}
        </Flex>
      ),
    },
    {
      title: "GL-Title",
      dataIndex: "glAcct",
      // titleType: "Input",
      width: 120,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Material Pick-Up Date',
      dataIndex: "invoiceDateAp",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'invoiceDateAp', 'DatePicker'),
    },
    {
      title: 'Hardware Store',
      dataIndex: "storeName",
      // titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'storeName'),
    },
    // {
    //   title: "Request No.",
    //   dataIndex: "requestNo",
    //   titleType: "Input",
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: (e) => tableFilterFn(e, "requestNo"),
    // },
    {
      title: 'Supervisor',
      dataIndex: "supervisor",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'supervisor')
    },
    {
      title: 'Maintenance Role',
      dataIndex: "vendorType",
      titleType: 'Select',
      width: 90,
      isSorter: true,
      sortterMultiple: 3,
      selectOptions: [
        { label: "Maint.Woker", value: "1" },
        { label: "Contractor", value: "2" },
      ],
      render: (text) => {
        const requestStatusMatch = {
          "1": "Maint.Woker",
          "2": "Contractor",
        }
        return requestStatusMatch[text] || ""
      },
      onChange: e => tableFilterFn(e, 'vendorType', 'Select'),
    },
    {
      title: 'Maintenance Name',
      dataIndex: "vendorName",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'vendorName')
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const searchParams = getPropsParamsFn()
    const params = {
      page: current || pagination.current ,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      usid: searchParams.email,
      type: searchParams.module,
      batch: searchParams.batch,
      storeName: searchParams.storeName,
    };
    const response = await http.get(api.CAMaintenanceMaterialAp, { params });
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    // setSelectedList([])
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }))
    setTableLoading(false);
  };

  const handleTableChange = (pagination, filters, sorter) => {
    getTableListFn(pagination.current, pagination.pageSize, tableHead);
  };

  const materialShowInvoiceFn = async() => {
    const { maintenanceMaterialInvoiceId } = currentRecord
    setLoading(true)
    const response = await http.get(api.MaterialShowInvoice, {params: { maintenanceMaterialInvoiceId }});
    if (response.code === "1") {
      form.setFieldsValue({
        invoiceAmount: response.data?.invoiceAmount,
        invoiceNumber: response.data?.invoiceNumber,
        invoiceDate: dayjs(response.data?.invoiceDate) || '',
        filePaths: response.data?.fileList?.map(item => item.relativePath)
      })
      customUploadNewRef.current.initUpdateList(response.data?.fileList?.map(item => ({...item, allPath: item.url, name: item?.name || item?.fileName})));
    } else {
      message.error(response.msg || "Failed to fetch user data");
    }
    setLoading(false)
  }

  useEffect(() => {
    if(uploadInvoiceFlag){
      materialShowInvoiceFn()
    }
  }, [uploadInvoiceFlag])

  const getDictionaryFn = async() => {
    const response = await http.get(api.getDictionary, { params: {
        type:'util_payment',
        value: 'propType'
    }});
    setPropTypeList(response)
  }

  const initColunmsFn = () => {
    setSelectedList([]);
    setTableHead(initTableHead);
    setColumns(initColumns);
  }
    
  useEffect(() => {
    getDictionaryFn()
  }, [])

  useEffect(() => {
    if(propTypeList?.length){
      setColumns(initColumns);
    }
  }, [propTypeList]);

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])
  
  // 提交数据
  const handleSubmit = async () => {
    setBtnLoading(true)
    const values = await approvalForm.validateFields();
    // 合并数据：表格选中的数据 + 表单数据
    const data = {
      ...values,
      ids: selectedList.map(item => item.vendorPaymentId),
      approvedOrRejected,
      batchGroup: getPropsParamsFn().batch,
      // usid: selectedList.map(item => item.usid)
    };
    const response = await http.post(api.getCheckApprovalApprove, data);
    if(response.code === '1'){
      message.success(`${approvedOrRejected} success!`);
      setOpenApproval(false);
      setRefreshKey(+new Date())
    }else{
      message.error(`${approvedOrRejected} failed!`);
    }
    setBtnLoading(false)
  };
 
  const approveOrRejectFn = (approvedOrRejected) => {
    if (!selectedList.length) {
      message.warning("Please select at least one item");
      return;
    }
    setOpenApproval(true);
    setApprovedOrRejected(approvedOrRejected);
    // 设置表单初始值，包括默认日期
    approvalForm.setFieldsValue({
      transactionCount: '1',
      noLimit: 'no'
    });
  };

  const getPropsParamsFn = () => {
    const searchParams = new URLSearchParams(location.search);
 
    const params = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }
    return params
  }

  const handleCellClick = async (record, flag = false) => {
    const response = await http.get(api.commonShowPayment, { params: {
      vendorPaymentId: record.latestPaymentId,
    }});
    const val = response.code === '1' ? response.data : {}
    const invoiceDateTemp = dayjs(flag ? val.invoiceDate : new Date())
    setAddRecord({ 
      ...record,
      ...val,
      vendorPaymentId: record.latestPaymentId,
      type: 'businessLicense',
      invoiceDate: invoiceDateTemp,
      amount: val?.amount || 0,
      serviceStartDate: val?.serviceStartDate && dayjs(val?.serviceStartDate) || null,
      serviceEndDate: val?.serviceEndDate && dayjs(val?.serviceEndDate) || null,
      invoiceTenant: String(val.invoiceTenant),
      foreignId: val?.foreignId || record?.vendorUtilPaymentId,
      filePaths: val?.filePaths || [],
      isEdit: flag,
      noSubmitBtn: true,
      usid: val?.usid
    });
    setAddOpen(true);
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
      >
        <div className="topLeft">
          <Space size="small">
            {commonFn.btnAuthorityFlag('Approval') && <Tooltip
              placement="topLeft"
              title="Approval The Requests For Approval From Employee"
            >
              <Button className="btnGreen" style={{marginRight: 0}} onClick={() => approveOrRejectFn('Approved')}>
                <CheckOutlined />
                Approval
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('Reject') && <Tooltip
              placement="topLeft"
              title="Reject The Requests For Approval From Employee"
            >
              <Button className="btnWarning" style={{marginLeft: 0}} onClick={() => approveOrRejectFn('rejected')}>
               <CloseOutlined />
                Reject
              </Button>
            </Tooltip> || null}
            {commonFn.btnAuthorityFlag('SelectedAmount') && <Button className="btnGreen" style={{cursor: 'text'}}>Selected Amount:{
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(selectedList.map(item => item.amount).reduce((acc, curr) => acc + curr, 0))
            }</Button> || null}
          </Space>
        </div>
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
          onChange: (selectedRowKeys, selectedRows) => {
            setSelectedList(selectedRows);
          },
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
      />

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        maskClosable={false}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        confirmLoading={btnLoading}
        width="30%"
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to approve these checks?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: `${approvedOrRejected === 'Approved' ? 'Approve' : 'Reject'} ${selectedList.length} Check(s).`,
                }
              ]}
            />
          </Form.Item>

          {approvedOrRejected === 'Approved' && <Form.Item
            name="noLimit"
            label={<span >Do you want to approve the amount over {<span style={{color:'#a94442',textDecoration:'underline'}}>
              {
                new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0,
                }).format(5000)
              }
            </span>} with signature</span>}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "no",
                  label: "No",
                },
                {
                  value: "yes",
                  label: "Yes",
                },
              ]}
            />
          </Form.Item> || null}

          {approvedOrRejected !== 'Approved' && <Form.Item
            name="rejectedReason"
            label="Rejected Reason"
            style={{ flex: 2 }}
          >
            <Input placeholder="" />
          </Form.Item> || null}
        </Form>
      </Modal>
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <HomeOutlined style={{ marginRight: "8px" }} />
            File
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={filedModalFlag}
        onCancel={() => setFiledModalFlag(false)}
        footer={null}
        maskClosable={false}
        // destroyOnClose={true}
        width="80%"
      >
      <div
        key={detailRecord?.vendorPaymentId}
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        <CustomUpload
          setFilePaths={setFilePaths} 
          filePaths={filePaths} 
          setBtnDisabled={setBtnDisabled}
          btnDisabled={btnDisabled}
          isEdit={true}
          vendorPaymentId={detailRecord?.vendorPaymentId || undefined}
          foreignId={detailRecord?.vendorPaymentId || undefined}
          preCalFile={detailRecord?.preCalFile || undefined}
          type={detailRecord?.type || undefined}
          customConfig={{
            pdfHeight: '62vh',
            noShowUpload: true,
            noSubmitBtn: true,
            pageName: 'CheckApproval'
          }}
        />
        <div style={{textAlign: 'center', marginTop: 20}}>
          <Button onClick={() => setFiledModalFlag(false)}>
            cancel
          </Button>
        </div>
      </div>
      </Modal>

      <PDFModal ref={PDFModalRef} record={currentRecord} />

      <AddModal 
        addopen={addopen}
        form={form}
        formTenant={formTenant}
        handleModalSubmitlFn={() => {setAddOpen(false); getTableListFn(pagination.current, pagination.pageSize, tableHead)}}
        handleModalCancelFn={() => setAddOpen(false)}
        record={addRecord}
      />

      <Modal
        title="View Invoice"
        width="80%"
        maskClosable={false}
        open={uploadInvoiceFlag}
        onCancel={() => (setUploadInvoiceFlag(false))}
        footer={false}
      >
        <Form
          form={form}
          layout="horizontal"
          labelCol={{span: 8}}
          wrapperCol={{span: 16}}
        >
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Form.Item
              name="invoiceDate"
              label="Invoice Date"
              rules={[{ required: true, message: "Invoice Date is required!" }]}
            >
              <DatePicker
                disabled
                style={{ width: "100%" }}
                format="MM/DD/YYYY"
                getPopupContainer={(trigger) => trigger.parentElement}
              />
            </Form.Item>

            {commonFn.formInputNumberDoc({
              name: 'invoiceAmount', 
              label: 'Invoice Amount',
              form,
              disabled: true,
              // isNoRequired: true,
              validator: (_, value, callback) => {
                if(value >= 1000000){
                  callback('The Amount Must Be Between 0 And 1000000.')
                } else {
                  callback()
                }
              }
            })}

            <Form.Item
              name="invoiceNumber"
              label="Invoice #"
              rules={[{ required: true, message: 'Invoice # is required!' }]}
            >
              <Input
                disabled
                placeholder="Please input Invoice #"
              />
            </Form.Item>
          </Col>
          <Col span={16}>
          <div
            style={{
              marginBottom: "16px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            <HomeOutlined style={{ marginRight: "8px" }} />
            Files
          </div>
          <Form.Item
            name="filePaths" 
            label="Files"
            labelCol={{ span: 0 }} 
            wrapperCol={{ span: 24 }}
            rules={[{ required: true, message: "Files is required!" }]}
          >
            <CustomUploadNew1
              ref={(el) => (customUploadNewRef.current = el)}
              customConfig={{
                pdfHeight: "76vh",
                notMultiple: true,
                accept: ".jpg, .jpeg, .png, .pdf",
                status: 'add',
                disabled: true,
                noUploadBtn: true
              }}
              setFilePaths={setFilePaths} 
              filePaths={filePaths} 
              setBtnDisabled={setBtnDisabled}
              btnDisabled={btnDisabled}
            />
          </Form.Item>
          </Col>
        </Row>
        </Form>
      </Modal>
    </div>
  );
});
export default MainTable;
